import { Box, Tooltip } from "@mui/material"
import { If } from "lib/@components/if"
import Iconify from "minimals-template/components/Iconify"

export function ChangeTypeIcon({ show, icon, color, title }) {
    return (
        <Tooltip title={show ? title : ""}>
            <Box sx={{ width: 20, height: 20, display: "flex", alignItems: "center", justifyContent: "center" }}>
                <If truthy={show}>
                    <Iconify icon={icon} sx={{ fontSize: 18, color }} />
                </If>
            </Box>
        </Tooltip>
    )
}
